import React from 'react';
import './ProfileButton.scss';

interface ProfileButtonProps {
    /** Status of the button */
    status: 'login' | 'logged-in';
    /** Username for logged-in state */
    username?: string;
    /** Optional click handler */
    onClick?: () => void;
    /** Optional href */
    href?: string;
    /** Optional className for custom styling */
    className?: string;
    /** Current language */
    currentLang?: 'en' | 'zh';
    /** Show loading overlay for logged-in account button */
    isLoading?: boolean;
}

const ProfileButton: React.FC<ProfileButtonProps> = ({ 
    status, 
    username, 
    onClick, 
    href = '#',
    className = '',
    currentLang = 'en',
    isLoading = false,
}) => {
    return (
        <a 
            href={href} 
            className={`login-profile-btn ${status === 'logged-in' ? 'my-account' : ''} ${isLoading ? 'loading' : ''} ${className}`}
            onClick={onClick}
            aria-busy={isLoading ? 'true' : 'false'}
        >
            {status === 'login' ? (
                currentLang === 'zh' ? '登入/註冊' : 'Sign up / Login'
            ) : (
                <>
                    <i className="icon-user"></i>
                    <div className="login-info">
                        <span className="username">{username}</span>
                        <span className="view-acct">{currentLang === 'zh' ? '賬戶查詢' : 'View Account'}</span>
                    </div>
                </>
            )}
            {isLoading && (
                <span className="account-spinner-overlay" aria-hidden="true">
                    <span className="spinner-border"></span>
                </span>
            )}
        </a>
    );
};

export default ProfileButton;
